'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _d3Shape = require('d3-shape');

exports.default = {
    'linear': _d3Shape.curveLinear,
    'linear-closed': _d3Shape.curveLinearClosed,
    'step': _d3Shape.curveStep,
    'step-before': _d3Shape.curveStepBefore,
    'step-after': _d3Shape.curveStepAfter,
    'basis': _d3Shape.curveBasis,
    'basis-open': _d3Shape.curveBasisOpen,
    'basis-closed': _d3Shape.curveBasisClosed,
    'bundle': _d3Shape.curveBundle,
    'cardinal': _d3Shape.curveCardinal,
    'cardinal-open': _d3Shape.curveCardinalOpen,
    'cardinal-closed': _d3Shape.curveCardinalClosed,
    'monotone': _d3Shape.curveMonotoneX
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/rumble-charts/lib/helpers/curves.js
 ** module id = 1532
 ** module chunks = 3
 **/